import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

import { NotesFilter, useEventCalendarViewState } from '../calendar-state';
import { useMeetingMinutesTabRows } from '../meeting-minutes-list-queries';

// All/With-notes segments for the Notes reading list. Counts derive from the same
// useMeetingMinutesTabRows the list renders from, so they count cards and cannot drift apart from
// what is on screen (the underlying query is cache-shared, so this costs no extra request). A
// meeting with three notes therefore counts three times. Unlike the neighboring
// EventCalendarTypeFilter, one segment is always selected: Radix single-select reports
// '' when the active segment is clicked again, which is ignored here instead of
// clearing the filter.
export const MeetingMinutesListFilter = ({ anchorDate }: { anchorDate: Date }) => {
    const { eventCalendarViewState, setEventCalendarViewState } = useEventCalendarViewState();
    const { notesFilter } = eventCalendarViewState;
    const { rows } = useMeetingMinutesTabRows(anchorDate);

    // No counts before the first load — the list shows its skeleton meanwhile.
    if (!rows) {
        return null;
    }

    const segments: Array<{ value: NotesFilter; label: string }> = [
        { value: 'all', label: `All (${rows.length})` },
        { value: 'withNotes', label: `with Notes (${rows.filter(({ note }) => note).length})` },
    ];

    return (
        <ToggleGroup
            type="single"
            value={notesFilter}
            onValueChange={(next) => next && setEventCalendarViewState({ notesFilter: next as NotesFilter })}
            className="border-cocoa-100 gap-2 rounded-full border bg-white p-1"
        >
            {segments.map(({ value, label }) => (
                <ToggleGroupItem
                    key={value}
                    value={value}
                    className="text-cocoa-500 hover:bg-cocoa-100 hover:text-gold-500 data-[state=on]:bg-cocoa-800 data-[state=on]:text-primary-foreground data-[state=on]:hover:bg-cocoa-700 data-[state=on]:hover:text-primary-foreground h-8 rounded-full px-4 font-thin first:rounded-l-full last:rounded-r-full"
                >
                    {label}
                </ToggleGroupItem>
            ))}
        </ToggleGroup>
    );
};
